import React from "react"
import Cabecalho from "../Cabecalho"
import { EntregadoresForm } from "./components/EntregadoresForm"

export function ListarEntregadores() {
    return (
        <>
            <Cabecalho pagina="Entregadores" />
            <EntregadoresForm />
        </>
    )
}
